import React, { useState, useEffect } from "react";
import { UseAdvCustomer } from "./UseAdvCustomer";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseMyPC } from "../../hooks/UseMyPC";
import { useLocation } from "react-router-dom";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function AdvCustomerAutoComplete(props) {
  const { getAdvCustomerList, getAdvCustomerByID } = UseAdvCustomer();
  const [customerRes, setCustomerRes] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [search, setSearch] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const { myPc, goToFirstPage, setScrollTo, refresh } = UseMyPC();

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }

    if (search.length > 0) {
      setProgress(true);
      getAdvCustomerList(
        myPc,
        search,
        (customer) => {
          setOpen(true);
          setCustomerRes(customer.items);
        },
        false
      );
    } else {
      setCustomerRes([]);
    }
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  useEffect(() => {
    if (!props.selectedCustomerID) {
      setSelectedCustomer();
    }
  }, [props.selectedCustomerID]);

  useEffect(() => {
    if (customerRes && props.selectedCustomerID) {
      getAdvCustomerByID(props.selectedCustomerID, (customer) => {
        setSelectedCustomer(customer);
      });
    }
  }, [customerRes, props.selectedCustomerID]);

  useEffect(() => {
    if (selectedCustomer) {
      props.setState({
        ...props.state,
        customerID: selectedCustomer.id,
      });
    }
  }, [selectedCustomer]);

  return customerRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.Offer && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedCustomer ? selectedCustomer : ""}
        options={customerRes ? customerRes : []}
        open={open}
        onClose={() => setOpen(false)}
        defaultValue={props.state.customerID ? props.state.customerID : ""}
        getOptionLabel={(items) => (items.companyName ? items.companyName : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            error={props.errorState}
            {...params}
            label="طرف قرارداد"
            onChange={(evt) => {
              setScrollTo(undefined);
              setSearch(evt.target.value);
            }}
            placeholder="جستجو طرف قرارداد..."
          />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.companyName ? option.companyName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedCustomer(newValue);
            // props.setName(newValue.customer);
            props.setState({
              ...props.state,
              customerID: newValue.id,
            });
            setCustomerRes([]);
            setSearch("");
            setOpen(false);
          } else {
            setSelectedCustomer();
            setSearch("");
            props.setState({
              ...props.state,
              customerID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAdvCustomerList(
            myPc,
            "",
            (contract) => {
              setCustomerRes(contract);
            },
            false
          );
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/advertismentcustomers" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
